import React from 'react'
import { FooterLogoSec } from '../HeaderAndfooter/FooterLogoSec';
import { FooterUsefullLinksColm } from '../HeaderAndfooter/FooterUsefullLinksColm';
import { FooterFollowUs } from '../HeaderAndfooter/FooterFollowUs';
import { FooterBackToTop } from '../HeaderAndfooter/FooterBackToTop';

export default function Footer() {
  return (
    <footer>
      <div className="container">
        <div className="row">
          <div className="col-lg-3"><FooterLogoSec /></div>
          <div className="col-lg-3 col-sm-4"><FooterUsefullLinksColm /></div>
          <div className="col-lg-3 col-sm-4"><FooterFollowUs /></div>
          <div className="col-lg-3 col-sm-4"><FooterBackToTop /></div>
        </div>
      </div>
    </footer>
  )
}
